/**
 * How long a comment may be.
 *
 * Kept in one place because the number is enforced in three: the composer under a
 * post, the composer inside the comments sheet, and the edit dialog. They drifted
 * apart the last time it changed, so a member could write a comment they were then
 * unable to edit without losing the end of it.
 *
 * The backend does not cap comment length at all, so this is the only limit there
 * is — raising it here raises it everywhere.
 */
export const MAX_COMMENT_LENGTH = 1000;
